import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, Type } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { IDatabaseGroupingConfiguration } from './model/IDatabaseGroupingConfiguration';
import { IDmsSyncConfig } from './model/IDmsSyncConfig';
import { DatabaseSynchroService, DATABASES_GROUPING_CONFIG, DMS_SYNC_CONFIG } from './services/database-synchro.service';

const components: Type<any>[] = [
];

@NgModule({
	declarations: components,
	imports: [
		CommonModule,
		IonicModule,
	],
	exports: components,
	providers: [DatabaseSynchroService]
})
export class DatabaseSynchroModule {
	public static forRoot(paDatabasesGroupingConfigs: IDatabaseGroupingConfiguration[], poDmsSyncConfig: IDmsSyncConfig): ModuleWithProviders<DatabaseSynchroModule> {
		return {
			ngModule: DatabaseSynchroModule,
			providers: [
				{ provide: DATABASES_GROUPING_CONFIG, useValue: paDatabasesGroupingConfigs },
				{ provide: DMS_SYNC_CONFIG, useValue: poDmsSyncConfig }
			]
		}
	}
}